import { Specification } from './specification.model';
import { SpecificationResponse } from './specification-response.model';
import { SpecificationType } from './specification-type.model';

// This class is for saving Specifications.
export class SpecificationRequest {
    specificationCode?: string;
    planningLineCodes?: string[] = [];
    parameterCode: string;
    parameterName: string;
    specificationUnit: SpecificationUnit;
    expectedValue: string;
    lowerLimit: string;
    upperLimit: string;
    specificationTypeId: number;
    sampleId?: number;
    testCodes?: string[] = [];
}

export class SpecificationUnit {
    id?: string;
    numeratorUnitCode: string;
    numeratorUnitName: string;
    denominatorUnitCode: string;
    denominatorUnitName: string;
}

export interface ISpecificationDetails {
    parameterCode?: string;
    parameterName?: string;
    specification?: Specification;
    specificationResponse?: SpecificationResponse;
    planningLineIds?: number[];
    specificationType?: SpecificationType;
    specifications?: SpecificationRequest[];
    specificationIdsForDelete?: string[];
}
